import React from "react";

function App({
}) {
  return <a href="hello-world.html">See the Hello World page</a>;
}

export default App;
